import React, {Component} from 'react';
import './css/App.css';
import AppNavbar from './Sidebar';
import Header from './Header';
import Favicon from "react-favicon";
import MetaTags from "react-meta-tags";
import axios from "axios";
import ConsoleHelper from "./ConsoleHelper";


class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showComponent : false
        }
    }

    componentDidMount() {

        axios.get(`getLoggedUserName?JSESSIONID=${sessionStorage.getItem('COOKIE')}`)
            .then(response => {
                ConsoleHelper("Welcome  page with username as %s and seession id as %s ",response.data,  sessionStorage.getItem('COOKIE'));
                this.setState({ loggedInUser: response.data })
                // setter
                sessionStorage.setItem('loggedUserStorage', response.data);
                console.log("Welcome user with user  %s ",sessionStorage.getItem("loggedUserStorage"));
            }).finally(()=> {
        })
            .catch(error => {
                console.log("GOT ERROR HERE for Get LoggedIn User",error);
            });


    }

    render() {

        const welcome = {
            height: '1000px',
            backgroundImage: "linear-gradient(to right, rgb(136 158 201), rgb(0 33 112))",
            color : 'white'
        };

        return (
            <body data-sidebar="colored">
            <div id="layout-wrapper">
                <Header />
                <AppNavbar data={this.state}/>
            </div>
            <div className="main-content">
                <Favicon url='https://passporttechnology.com/images/base/favicon-16x16.png' />
                <MetaTags>
                    <title>DataStream Version 2.0</title>
                    <meta name="description" content="Some description." />
                    <meta property="og:title" content="DataStream Version 2.0" />
                </MetaTags>
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box d-flex align-items-center justify-content-between">
                                    <h4 className="mb-0">Home</h4>


                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl">
                                <div className="card">
                                    <div className="card-body" style={welcome}>
                                        <h3 align="center" style={{ color: 'white' }}>Welcome to ATM DataCenter</h3>
                                        <div className="alert is-primary">
                                            {/*<p className="alert-title"><span className="docon docon-status-info-outline"
                                                                             aria-hidden="true"></span> Important</p>
                                            <p>The Internet Explorer 11 desktop application will be retired and go out
                                                of support on June 15, 2022 (for a list of what's in scope, see the <a target="_blank" rel="noopener noreferrer"
                                                    href="https://aka.ms/IEModeFAQ" data-linktype="external" style={{ color: 'white' }}><strong>FAQ >></strong></a>).
                                                The same IE11 apps and sites you use today can open in Google Chrome
                                                . Learn more <a target="_blank" rel="noopener noreferrer"
                                                    href="https://aka.ms/IEModeBlog" data-linktype="external" style={{ color: 'white' }}><strong>here >></strong></a>.
                                            </p>*/}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>;

            </body>
        );
    }

    //Function to update state from userView
    onUpdate (data) { this.setState({ data }) }
}

export default Home;